import { useEffect, useRef, useState } from "react";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { SidebarPanel } from "../SidebarPanel";

export const LeftSidePanel = () => {
  const { isWideDesktop } = useBreakpoint();
  const [isExpanded, setIsExpanded] = useState(isWideDesktop);
  const prevIsWideDesktop = useRef(isWideDesktop);

  useEffect(() => {
    if (prevIsWideDesktop.current && !isWideDesktop) {
      setIsExpanded(false);
    } else if (!prevIsWideDesktop.current && isWideDesktop) {
      setIsExpanded(true);
    }
    prevIsWideDesktop.current = isWideDesktop;
  }, [isWideDesktop]);

  return (
    <div
      className={`row left-side-panel ${
        isExpanded ? "" : "left-side-panel-small"
      }`}
    >
      <SidebarPanel isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
    </div>
  );
};
